import React from 'react';
import { FlightDropdown } from '@flybits/design-system';
import {
  PushUniversalActionTypes as ActionTypes,
  PushFormClassPrefix as CLASS_PREFIX,
} from 'components/ExperienceCanvas/constants';
import { PushUniversalAction } from 'components/ExperienceCanvas/types';
import { EVENT_KEYS } from 'types/events';

type ActionTypeSelectorProps = {
  selectedActionType: PushUniversalAction;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onSelect: (actionType: PushUniversalAction) => void;
};

const ActionTypeSelector = ({ selectedActionType, isOpen, onOpenChange, onSelect }: ActionTypeSelectorProps) => (
  <FlightDropdown
    className={`${CLASS_PREFIX}__actionlink__field`}
    isActive={isOpen}
    isControlledByIsActive
    handleClickOutside={() => onOpenChange(false)}
    trigger={
      <button
        className={`${CLASS_PREFIX}__actionlink__trigger ${
          isOpen ? `${CLASS_PREFIX}__actionlink__trigger--open` : ''
        }`}
        aria-label="Select Universal Action"
        onClick={() => onOpenChange(!isOpen)}
        onKeyDown={(e) => {
          if (e.key === EVENT_KEYS.ENTER) onOpenChange(!isOpen);
        }}
      >
        {selectedActionType.name}
      </button>
    }
    maxHeight="50vh"
  >
    <>
      <div className={`${CLASS_PREFIX}__actionlink__field__item--header`}>
        Universal Actions (Requires Concierge version {'>'}= 4.4)
      </div>
      {ActionTypes.filter((at) => at.minVersion < 5).map((at) => (
        <button
          key={`push-at-${at.name}`}
          className={`${CLASS_PREFIX}__actionlink__field__item`}
          aria-label={`select ${at.name} form`}
          onClick={() => onSelect(at)}
          onKeyDown={(e) => {
            if (e.key === EVENT_KEYS.ENTER) onSelect(at);
          }}
        >
          {at.name}
        </button>
      ))}
      <div className={`${CLASS_PREFIX}__actionlink__field__item--header`}>
        Universal Actions (Requires Concierge version {'>'}= 5)
      </div>
      {ActionTypes.filter((at) => at.minVersion > 4.4).map((at) => (
        <button
          key={`push-at-opt-${at.name}`}
          className={`${CLASS_PREFIX}__actionlink__field__item`}
          aria-label={`select ${at.name} form`}
          onClick={() => onSelect(at)}
          onKeyDown={(e) => {
            if (e.key === EVENT_KEYS.ENTER) onSelect(at);
          }}
        >
          {at.name}
        </button>
      ))}
    </>
  </FlightDropdown>
);

export default ActionTypeSelector;
